import React from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { linkBase } from '@/src/mobile/components/Link';
import styles from './index.css';
import Item from './Item';

const BottomBar = () => {
    const list = [
        {
            title: '追踪榜',
            url: `${linkBase}/loc/timeline`,
            reg: /.*\/timeline$/g,
            iconClass: 'hotRank',
            needLogin: false,
        },
        {
            title: '我的追踪',
            url: `${linkBase}/loc/timeline/myfollow`,
            reg: /.*\/timeline\/myfollow\/?.*/g,
            iconClass: 'myfollow',
            needLogin: true,
        },
        // {
        //   title: "我的爆料",
        //   url: `${linkBase}/loc/timeline/myspill`,
        //   reg: /.*\/timeline\/myspill\/?.*/g,
        //   iconClass: "myspill",
        //   needLogin: true,
        // },
    ];

    return (
        <>
            <div className={styles.placeholder} />
            <div className={styles.wrap}>
                <div className={styles.list}>{list.map(item => <Item content={item} key={item.title} />)}</div>
            </div>
        </>
    );
};

export default errorBoundary(BottomBar);
